import JSDB from 'fromKotlin/nk';

/** Company-level flag from `basic_information.attendance` (mirrored on `User.attendance`). */
export function companyAttendanceMode(): number {
    const a = JSDB().getUser()?.first?.attendance;
    const mode = Number(a ?? 0);
    return mode === 2 || mode === 3 ? mode : mode === 1 ? 1 : 0;
}

export function companyAttendanceEnabled(): boolean {
    return companyAttendanceMode() >= 1;
}
